module.exports = __webpack_public_path__ + "static/media/logs.inactive.9b79ea4b.svg";